import bgClanBattles from '~/assets/wows/images/bg/clan-battles.jpg';
import bgClanBattles2x from '~/assets/wows/images/bg/clan-battles@2x.jpg';
import bgClanStars from '~/assets/wows/images/bg/clanstars.jpg';
import bgClanStars2x from '~/assets/wows/images/bg/clanstars@2x.jpg';
import bgCreate from '~/assets/wows/images/bg/create.jpg';
import bgMembers from '~/assets/wows/images/bg/members.jpg';
import bgMembers2x from '~/assets/wows/images/bg/members@2x.jpg';
import bgClanWars from '~/assets/wows/images/bg/naval-battles.jpg';
import bgClanWars2x from '~/assets/wows/images/bg/naval-battles@2x.jpg';
import bgPatrols from '~/assets/wows/images/bg/patrols.jpg';
import bgSearch from '~/assets/wows/images/bg/search.jpg';
import bgSearch2x from '~/assets/wows/images/bg/search@2x.jpg';
import bgTasks from '~/assets/wows/images/bg/tasks.jpg';
import bgTasks2x from '~/assets/wows/images/bg/tasks@2x.jpg';
import bgTreasury from '~/assets/wows/images/bg/treasury.jpg';

const backgrounds = {
  clanBattles: [bgClanBattles, bgClanBattles2x],
  clanStars: [bgClanStars, bgClanStars2x],
  clanWars: [bgClanWars, bgClanWars2x],
  create: bgCreate,
  members: [bgMembers, bgMembers2x],
  search: [bgSearch, bgSearch2x],
  tasks: [bgTasks, bgTasks2x],
  treasury: bgTreasury,
  patrols: bgPatrols,
} as const;

export default backgrounds;
